export const messages = {
  en: {
    adminIndex: {
      home: 'Home',
      platformData: 'Platform Data',
      paymentCount: 'Payment Count',
      paymentAmount: 'Payment Amount',
      repairCount: 'Repair Count',
      communityFeeStats: 'Community Fee Statistics',
      communityRepairStats: 'Community Repair Statistics'
    },
    propertyIndex: {
      home: 'Home',
      dashboard: 'Dashboard',
      communityInfo: 'Community Information',
      building: 'Building',
      house: 'House',
      shop: 'Shop',
      parkingSpace: 'Parking Space',
      residentReg: 'Resident Registration',
      registerResident: 'Register Resident',
      vehicle: 'Vehicle',
      viewVehicle: 'View Vehicles',
      unit: 'unit',
      ownerFeedback: 'Owner Feedback',
      noFeedback: 'No feedback content currently',
      feedback: 'feedback',
      completed: 'Completed',
      followingUp: 'Following up',
      transferRepair: 'Transferred to repair order',
      repairStats: 'Repair Statistics',
      allRepair: 'All Repairs',
      toBeDispatched: 'To be dispatched',
      processing: 'Processing',
      processed: 'Processed',
      complaintStats: 'Complaint Statistics',
      allComplaint: 'All Complaints',
      repairInfo: 'Repair Info',
      unprocessed: 'Unprocessed',
      residentRegStats: 'Resident Registration Statistics',
      unregistered: 'Unregistered',
      registered: 'Registered',
      unboundRoom: 'Unbound Room',
      boundRoom: 'Bound Room',
      residentInfo: 'Resident Info'
    }
  },
  zh: {
    adminIndex: {
      home: '首页',
      platformData: '平台数据',
      paymentCount: '缴费数',
      paymentAmount: '缴费金额',
      repairCount: '报修单数',
      communityFeeStats: '园区缴费统计',
      communityRepairStats: '园区报修统计'
    },
    propertyIndex: {
      home: '首页',
      dashboard: '控制台',
      communityInfo: '园区信息',
      building: '楼宇',
      house: '房屋',
      shop: '商铺',
      parkingSpace: '车位',
      residentReg: '住户登记',
      registerResident: '登记住户',
      vehicle: '车辆',
      viewVehicle: '查看车辆',
      unit: '个',
      ownerFeedback: '合同到期提醒',
      noFeedback: '当前没有业主反馈内容',
      feedback: '反馈',
      completed: '完成',
      followingUp: '跟进中',
      transferRepair: '已转报修单',
      repairStats: '报修统计',
      allRepair: '全部报修',
      toBeDispatched: '待派单',
      processing: '处理中',
      processed: '已处理',
      complaintStats: '投诉统计',
      allComplaint: '全部投诉',
      repairInfo: '报修信息',
      unprocessed: '未处理',
      residentRegStats: '住户注册统计',
      unregistered: '未注册',
      registered: '已注册',
      unboundRoom: '未绑定房屋',
      boundRoom: '已绑定房屋',
      residentInfo: '住户信息'
    }
  }
}